export const paginationPageSizes = [10, 25, 50, 100];
